export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getSubwayList: function getSubwayList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subway/get",
        method: "get",
        params: data
      });
    },
    getSubwayListByPy: function getSubwayListByPy() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/resource/".concat(data.city_id, "/subways/"),
        method: "get",
        params: data
      });
    },
    addSubway: function addSubway() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subway/add",
        method: "post",
        data: data
      });
    },
    updateSubway: function updateSubway() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subway/update",
        method: "post",
        data: data
      });
    },
    deleteSubway: function deleteSubway() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subway/delete",
        method: "post",
        data: data
      });
    },
    updateSubwaySort: function updateSubwaySort() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subway/updateSort",
        method: "post",
        data: data
      });
    }
  };
});